import { Fragment } from "react";
import assets from "../../assets";
import "./styles.sass";
import useHandler from "./handler";
import {
  LANGUAGE_OPTIONS,
  LANGUAGE_OPTIONS_CBSE,
  LANGUAGE_TN_STATE_BOARD,
  SELECT_BOX_COLORS,
} from "../../utils/constant";
import { CommonPopup } from "../pop-up";
import { ROUTE_LEARNING_ASSETS } from "../../route";

export const AiGenerator = () => {
  const {
    DURATION_OPTIONS,
    user,
    role,
    togglebtn,
    conceptOptions,
    setConceptOptions,
    getConceptDetails,
    subjects,
    openDropdown,
    selectedLanguage,
    languageRef,
    conceptText,
    chapterRef,
    subjectRef,
    subjectOptions,
    chapterOptions,
    preferredType,
    selectMode,
    isFormValid,
    onSelectSubject,
    duration,
    handleDurationChange,
    filteredDurationOptions,
    durationType,
    durationDropdown,
    setSelectedChapter,
    setSubjects,
    setConceptText,
    setOpenDropdown,
    setSelectedLanguage,
    setPreferredType,
    setSelectMode,
    deleteSubject,
    navigate,
    addSubject,
    addChapters,
    deleteChapter,
    addConcept,
    deleteConcept,
    resetForm,
    handleGenerate,
    setDuration,
    setDurationDropdown,
    setDurationType,
    popupData,
    setPopupData,
    handleExistingAssets,
    filteredAssets,
    assetPopupOpen,
    setAssetPopupOpen,
    toggleNotify,
  } = useHandler();

  const isVideoMode = preferredType === "video";
  const USER_LANGUGE =
    user?.data?.focus === "CBSE"
      ? LANGUAGE_OPTIONS_CBSE
      : LANGUAGE_TN_STATE_BOARD;

  const renderSubjectsWrapperLong = (item, index) => {
    const { name, id } = item || {};
    return (
      <section key={id} className="chapter_container_wrapper">
        {/* SUBJECT */}
        <section className="subject_chapter_container" ref={subjectRef}>
          <section
            className="select_box"
            style={{
              backgroundColor:
                SELECT_BOX_COLORS[index % SELECT_BOX_COLORS.length],
            }}
          >
            {index + 1}
          </section>
          <section
            className="input_wrapper"
            onClick={() => {
              setOpenDropdown({
                type: "subject",
                subjectId: item.id,
              });
            }}
          >
            <h5>{name || "Select Subject"}</h5>
            <img src={assets.ic_chevron_down} alt="chevron_down" />
          </section>
          <img
            src={assets.ic_subject_delete}
            alt="subject_delete"
            className="subject_delete"
            onClick={() => deleteSubject(id)}
          />
          {openDropdown?.type === "subject" &&
            openDropdown?.subjectId === item.id && (
              <section className="options_list_chapter">
                {subjectOptions?.map((sub, i) => (
                  <p
                    key={i}
                    className="option_item"
                    onMouseDown={(e) => {
                      e.stopPropagation();

                      onSelectSubject({
                        subjectId: item.id,
                        subjectName: sub,
                      });
                    }}
                  >
                    {sub}
                  </p>
                ))}
              </section>
            )}
        </section>
        <section className="min_chapter_wrapper">
          {selectMode !== "random" && !isVideoMode && (
            <section className="min_content_wrapper">
              <img src={assets.ic_book} alt="ic_book" />
              <h4>Chapters</h4>
              <h5>Maximum 1 chapter per subject</h5>
            </section>
          )}
          {name && selectMode !== "random" && item?.chapters?.length < 1 && (
            <section
              className="add_btn_wrapper"
              onClick={() => addChapters(item?.id)}
            >
              <img src={assets.ic_add} alt="ic_add" />
              <h5>Add Chapter</h5>
            </section>
          )}
        </section>
        {/* CHAPTER */}
        {selectMode !== "random" &&
          item?.chapters?.map((chap, index) => (
            <section
              key={chap?.id}
              className="subject_chapter_container_wrapper"
            >
              <section
                key={id}
                className="subject_chapter_container"
                ref={chapterRef}
              >
                <section className="select_box1">{index + 1}</section>
                <section
                  className="input_wrapper"
                  onClick={() => {
                    setSelectedChapter(chap);
                    setOpenDropdown({
                      type: "chapter",
                      subjectId: item.id,
                      chapterId: chap.id,
                    });
                  }}
                >
                  <h5>{chap?.name || "Select Chapter"}</h5>
                  <img src={assets.ic_chevron_down} alt="chevron_down" />
                </section>
                <img
                  src={assets.ic_subject_delete}
                  alt="subject_delete"
                  className="subject_delete"
                  onClick={() => deleteChapter(id, chap.id)}
                />
                {openDropdown?.type === "chapter" &&
                  openDropdown?.subjectId === item.id &&
                  openDropdown?.chapterId === chap.id && (
                    <section className="options_list_chapter">
                      {chapterOptions[item.id]?.map((ch, i) => (
                        <p
                          key={i}
                          className="option_item"
                        onMouseDown={(e) => {
  e.stopPropagation();

  // Reset chapter concepts when chapter changes
  setSubjects((prev) =>
    prev.map((s) =>
      s.id === item.id
        ? {
            ...s,
            chapters: s.chapters.map((c) =>
              c.id === chap.id
                ? {
                    ...c,
                    name: ch,
                    concepts: [], // Clear old concepts
                  }
                : c,
            ),
          }
        : s,
    ),
  );

  setConceptOptions([]);

  if (!isVideoMode) {
    getConceptDetails({
      board: user?.data?.board,
      clas: user?.data?.class,
      medium: user?.data?.medium,
      subject: item.name,
      chapter: ch,
    });
  }

  setOpenDropdown(null);
}}
                        >
                          {ch}
                        </p>
                      ))}
                    </section>
                  )}
              </section>
              {!isVideoMode && selectMode !== "long" && !togglebtn && (
                <Fragment>
                  <section className="concept_desc_wrapper">
                    <section className="concept_desc">
                      <img src={assets.ic_plub} alt="ic_plub" />
                      <h6>
                        Concepts (Select{" "}
                        {role === "guest" ? "only 1" : "up to 3"})
                      </h6>
                    </section>
                    <h6>
                      {chap?.concepts?.length} of {role === "guest" ? 1 : 3}{" "}
                      selected
                    </h6>
                  </section>
                  <section className="subject_chapter_container">
                    {/* ✅ LEFT LABEL LIKE LESSON */}
                    <section className="select_box1">C</section>

                    {/* ✅ DROPDOWN INPUT */}
                    <section
                      className="input_wrapper"
                      onClick={() =>
                        setOpenDropdown({
                          type: "concept",
                          subjectId: item.id,
                          // unitId: unit.id,
                          chapterId: chap.id,
                        })
                      }
                    >
                      <h5>
                        {chap?.concepts?.length
                          ? chap.concepts.join(", ")
                          : "Select Concepts"}
                      </h5>
                      <img src={assets.ic_chevron_down} alt="" />
                    </section>

                    {/* ✅ DROPDOWN OPTIONS (SAME CLASS AS LESSON) */}
                    {openDropdown?.type === "concept" &&
                      openDropdown?.chapterId === chap.id && (
                        <section className="options_list_chapter">
                          {conceptOptions?.length > 0 ? (
                            conceptOptions.map((concept, i) => (
                              <p
                                key={i}
                                className="option_item"
                                onMouseDown={(e) => {
                                  e.stopPropagation();

                                  addConcept(
                                    item.id,
                                    // unit.id,
                                    chap.id,
                                    concept,
                                  );
                                }}
                              >
                                {concept}
                              </p>
                            ))
                          ) : (
                            <p className="option_item">No concepts found</p>
                          )}
                        </section>
                      )}
                  </section>
                  {/* <section className="subject_chapter_container1">
                    <section className="input_wrapper">
                      <input
                        placeholder="Enter concepts..."
                        name="conceptText"
                        value={conceptText[chap.id] || ""}
                        onChange={(e) =>
                          setConceptText((prev) => ({
                            ...prev,
                            [chap.id]: e.target.value,
                          }))
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            addConcept(id, chap.id, conceptText[chap.id]);
                            setConceptText((prev) => ({
                              ...prev,
                              [chap.id]: "",
                            }));
                          }
                        }}
                      />
                    </section>
                    <section
                      className="arrow_btn_wrapper"
                      onClick={() => {
                        addConcept(id, chap.id, conceptText[chap.id]);
                        setConceptText((prev) => ({ ...prev, [chap.id]: "" }));
                      }}
                    >
                      <img src={assets.ic_right_arrow} alt="right_arrow" />
                    </section>
                  </section> */}
                  <section className="add_chapters_wrapper">
                    {chap?.concepts?.map((concept, i) => (
                      <section key={i} className="add_chapters">
                        <h6>{concept}</h6>
                        <img
                          src={assets.ic_close_white}
                          alt="remove"
                          onClick={() => deleteConcept(id, chap.id, i)}
                        />
                      </section>
                    ))}
                  </section>
                  {chap?.concepts?.length >= 3 && (
                    <section className="min_chapter_alter_wrapper">
                      <img src={assets.ic_alert} alt="ic_alert" />
                      <h6>Maximum concepts reached</h6>
                    </section>
                  )}
                </Fragment>
              )}
            </section>
          ))}
        {item?.chapters?.length == 0 && selectMode !== "random" && (
          <section className="empty_chap_info_wrapper">
            <img src={assets.ic_info} alt="ic_info" />
            <h6 className="no_chap_text">No chapters added yet</h6>
            <h6 className="add_chap_yet">Click "Add Chapter" to get started</h6>
          </section>
        )}
      </section>
    );
  };

  return (
    <section>
      <section className="main_wrapper">
        <section className="ai_genertor_img_wrapper">
          <img src={assets.ic_learning_container} alt="img_ai_genertor" />
        </section>
        <section className="content_info_container">
          <section className="contentai_info_container">
            <section className="info_box">
              <img src={assets.ic_info_outline} alt="ic_info" />
            </section>
            <section>
              <h4>Content Generation Information</h4>
              <section className="content_ai_desc">
                <h5>
                  Board:{" "}
                  <span className="ai_board">
                    {user?.data?.board || "CBSE"}
                  </span>
                </h5>
                <section className="ai_divider"></section>
                <h5>
                  Class:{" "}
                  <span className="ai_board">
                    {`Grade ${user?.data?.class}` || "Grade 10"}
                  </span>
                </h5>
              </section>
            </section>

            <section className="ai_default_medium_wrapper">
              <h4>Medium</h4>
              <h5>{user?.data?.medium}</h5>
            </section>
          </section>
          <section className="content_setting_lang">
            <section className="lanuage_wrapper" ref={languageRef}>
              <h5>Content Language</h5>
              <section
                className="input_wrapper"
                onClick={() => setOpenDropdown("language")}
              >
                <h5>{selectedLanguage || "Select Language"}</h5>
                <img src={assets.ic_chevron_down} alt="chevron_down" />
              </section>
              {openDropdown === "language" && (
                <section className="options_list_lang">
                  {LANGUAGE_OPTIONS.map((item, i) => (
                    <p
                      key={i}
                      className="option_item"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedLanguage(item);
                        setOpenDropdown(null);
                      }}
                    >
                      {item}
                    </p>
                  ))}
                </section>
              )}
            </section>
            {!isVideoMode && (
              <section className="short-tab-wrapper">
                <section>
                  <section
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <h4>Content Generator Settings</h4>
                    <img
                      src={assets.ic_info_outline}
                      alt="info_outline"
                      style={{ width: "16px", height: "16px" }}
                    />
                  </section>
                  <h5 className="choose_text">
                    Choose between Custom, Short or Long content generation
                  </h5>
                </section>
                <section className="short_long_wrapper">
                  {/* SHORT */}
                  <section
                    className={`mode_item ${selectMode === "short" ? "active" : ""}`}
                    onClick={() => setSelectMode("short")}
                    style={{ position: "relative" }}
                  >
                    <section className="dot"></section>
                    <h5>Short Content</h5>
                    <div className="mode_tooltip">
                      Quick, high-level audio/video summaries for specific
                      topics. Perfect for rapid review.
                      <br />
                      <strong>⏱ ~30 seconds</strong>
                    </div>
                  </section>

                  {/* LONG */}
                  <section
                    className={`mode_item ${selectMode === "long" ? "active" : ""}`}
                    onClick={() => {
                      if (role === "guest") {
                        toggleNotify({
                          type: "success",
                          title: "Message",
                          description: "Please Subscribe",
                        });
                      } else {
                        setSelectMode("long");
                      }
                    }}
                    style={{ position: "relative" }}
                  >
                    <section className="dot"></section>
                    <h5>Long Content</h5>
                    <div className="mode_tooltip">
                      In-depth, full-chapter audio/video content. Best for
                      comprehensive learning and deep dives.
                      <br />
                      <strong>⏱ ~5–10 minutes</strong>
                    </div>
                  </section>

                  {/* CUSTOM */}
                  <section
                    className={`mode_item ${selectMode === "random" ? "active" : ""}`}
                    onClick={() => setSelectMode("random")}
                    style={{ position: "relative" }}
                  >
                    <section className="dot"></section>
                    <h5>Custom</h5>
                    <div className="mode_tooltip">
                      Personalized content generated to your specific filters
                      and duration preferences.
                      <br />
                      <strong>⏱ You choose the duration</strong>
                    </div>
                  </section>
                </section>
              </section>
            )}
          </section>
          <section className="preferred_content_wrapper">
            <h4> Content type</h4>
            <section className="preferred_type_container">
              <section
                className={
                  preferredType === "video"
                    ? "preferred_video"
                    : "preferred_type"
                }
                onClick={() => {
                  if (role === "guest") {
                    toggleNotify({
                      type: "success",
                      title: "Message",
                      description: "Please Subscribe",
                    });
                  } else {
                    setPreferredType("video");
                    setSelectMode(""); // ✅ NEW (custom internal mode)
                  }
                }}
              >
                <img src={assets.ic_youtube} alt="ic_youtube" />
                <h5> Video</h5>
              </section>
              <section
                className={
                  preferredType === "audio"
                    ? "preferred_video"
                    : "preferred_type"
                }
                onClick={() => {
                  setPreferredType("audio");
                  if (!selectMode) {
                    setSelectMode("short");
                  }
                }}
              >
                <img src={assets.ic_volume_green} alt="ic_volume_green" />
                <h5>Audio</h5>
              </section>
            </section>
            {!isVideoMode && selectMode === "random" && (
              <section className="preferred_duration_wrapper">
                <h4>Duration</h4>
                <section className="duration_input_wrapper">
                  {/* Duration Input */}
                  <input
                    type="number"
                    placeholder="Example: 1"
                    value={duration}
                    onChange={(e) => {
                      const value = e.target.value.slice(0, 2);
                      handleDurationChange(e.target.value);
                    }}
                  />

                  {/* Dropdown */}
                  <section
                    className="duration_dropdown"
                    onClick={() => setDurationDropdown(!durationDropdown)}
                  >
                    <p>{durationType}</p>
                    <img src={assets.ic_chevron_down} alt="dropdown" />
                  </section>
                </section>
                {durationDropdown && (
                  <section className="duration_options">
                    {filteredDurationOptions.map((item, i) => (
                      <p
                        key={i}
                        onMouseDown={(e) => {
                          e.stopPropagation();
                          setDurationType(item);
                          setDurationDropdown(false);
                        }}
                      >
                        {item}
                      </p>
                    ))}
                  </section>
                )}
                {/* <input  placeholder="Mins" name="duration" value={duration} onChange={(e)=> setDuration(e.target.value)}/> */}
              </section>
            )}
          </section>
        </section>
        <section className="subject_content_container">
          <img src={assets.ic_select_subject} alt="select_subject" />
          <section>
            <h4>Subjects</h4>
            <h5>
              {isVideoMode
                ? "Maximum 1 subject allowed"
                : selectMode === "random"
                  ? "Maximum 1 subject allowed"
                  : "Maximum 3 subjects allowed"}
            </h5>
          </section>
        </section>
        {subjects?.map(renderSubjectsWrapperLong)}
        {subjects.length <
          (isVideoMode ? 1 : selectMode === "random" ? 1 : 3) && (
          <section className="add_subject_wrapper" onClick={addSubject}>
            <img src={assets.ic_add_white} alt="ic_add_white" />
            <h5>Add Subject</h5>
          </section>
        )}
        {!isVideoMode && selectMode !== "random" && subjects.length >= 3 && (
          <section className="min_chapter_alter_wrapper">
            <img src={assets.ic_alert} alt="ic_alert" />
            <h6>Maximum subjects reached</h6>
          </section>
        )}

        <CommonPopup
          open={popupData.open}
          title={popupData.title}
          description={popupData.description}
          buttonText={popupData.buttonText}
          onClose={() => setPopupData((prev) => ({ ...prev, open: false }))}
          onConfirm={async () => {
            const id = popupData.assetId;

            setPopupData((prev) => ({ ...prev, open: false }));

            if (id) {
              const assets = await handleExistingAssets(id);

              if (assets?.length > 0) {
                setAssetPopupOpen(true); // ✅ open 2nd popup
              }
            } else {
              navigate(ROUTE_LEARNING_ASSETS);
            }
          }}
        />
        <CommonPopup
          open={assetPopupOpen}
          url={true}
          onClose={() => setAssetPopupOpen(false)}
        >
          {filteredAssets.map((asset) => (
            <div key={asset.asset_id}>
              {asset.type === "video" && (
                <video
                  onContextMenu={(e) => e.preventDefault()}
                  controlsList="nodownload"
                  width="800"
                  controls
                >
                  <source src={asset.url} type="video/mp4" />
                </video>
              )}

              {asset.type === "audio" && (
                <audio
                  onContextMenu={(e) => e.preventDefault()}
                  controlsList="nodownload"
                  controls
                >
                  <source src={asset.url} type="audio/mpeg" />
                </audio>
              )}
            </div>
          ))}
        </CommonPopup>
      </section>
      <section className="footer_btns_wrapper">
        <section className="form_btns">
          <section className="reset_form" onClick={resetForm}>
            <img src={assets.ic_refresh_blue} alt="ic_refresh_blue" />
            <h5>Reset Form</h5>
          </section>
          <button
            className="generate_btn"
            onClick={handleGenerate}
            disabled={!isFormValid()}
          >
            <img src={assets.ic_generate_magic} alt="ic_generate_magic" />
            <h5>Generate Content</h5>
          </button>
        </section>
      </section>
    </section>
  );
};
